import { useState } from "react";
import { UserMenu, Logo, PortfolioSelect } from "components";
import { SelectedContactName } from "components/Avatar/SelectedContactName";
import { PortfolioOption } from "components/PortfolioSelect/PortfolioSelect";
import {
  TOTAL_INVESTMENTS_OPTION_ID,
  useGetPortfolioOptions,
} from "hooks/useGetPortfolioOptions";
import { Navigate, useParams } from "react-router-dom";
import { useNavigateToPortfolioTab } from "./useNavigateToPortfolioTab";
import { useRedirectIfOnlyOnePortfolio } from "./useRedirectIfOnlyOnePortfolio";

export const PortfolioNavigationHeader = () => {
  const portfolioOptions = useGetPortfolioOptions();
  const { contactDbId, portfolioId: portfolioIdUrl } = useParams();
  const portfolioId = portfolioIdUrl
    ? parseInt(portfolioIdUrl, 10)
    : TOTAL_INVESTMENTS_OPTION_ID;
  const navigateToPortfolioTab = useNavigateToPortfolioTab();
  useRedirectIfOnlyOnePortfolio();
  const onPortfolioChange = (selectedOption: PortfolioOption) => {
    navigateToPortfolioTab(selectedOption.urlPrefix);
  };

    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
      setMenuOpen(prev => !prev);
    };

  // redirect to root when portfolioId does not match available portfolios
  if (
    portfolioId !== TOTAL_INVESTMENTS_OPTION_ID &&
    !portfolioOptions.some(
      (option) =>
        option.id === portfolioId ||
        //Extend this to a recursive operation to check subs of subs
        option?.subOptions?.some((subOption) => subOption.id === portfolioId)
    )
  ) {
    //handle impersonation mode
    if (contactDbId) return <Navigate to={`/impersonate/${contactDbId}/`} />;
    return <Navigate to="/" replace />;
  }

  return (
    <div className="z-20 px-2 pt-2 bg-white">
      <div className="container md:px-2 mx-auto">
        <div className="flex flex-wrap items-center">
          <div id="logo" className="order-1 md:order-1 md:mr-2 w-1/2 md:w-auto text-left">
            <Logo />
          </div>

          <div className="order-2 md:order-3 w-1/2 md:w-auto text-right">
            <div className="inline-flex flex-nowrap items-center space-x-2">
              <SelectedContactName onClick={toggleMenu}/>
              <UserMenu isOpen={menuOpen} toggleMenu={toggleMenu}/>
            </div>
          </div>
          
          <div className="md:flex-1 order-3 md:order-2 mt-2 md:mt-0 w-full">
            {portfolioOptions.length > 0 ? (
              <div className="md:max-w-[450px]">
              <PortfolioSelect
                portfolioOptions={portfolioOptions}
                portfolioId={portfolioId}
                onChange={onPortfolioChange}
              />
            </div>
            ) : (
              <div />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

